export const isEDMode =
  typeof window !== "undefined"
    ? window.location.href.indexOf("ed=1") > 0
    : false;

const timeoutDebounce = {};
export const debounce = (name, func, wait, immediate) => {
  return function () {
    const context = this;
    const args = arguments;

    const later = () => {
      timeoutDebounce[name] = null;

      if (!immediate) {
        func.apply(context, args);
      }
    };

    const callNow = immediate && !timeoutDebounce[name];

    clearTimeout(timeoutDebounce[name]);

    timeoutDebounce[name] = setTimeout(later, wait);

    if (callNow) {
      func.apply(context, args);
    }
  };
};

export const focusLoop = (e, selector) => {
  const tabPressed = e.key === "Tab" || e.keyCode === 9;

  if (!tabPressed) return;

  const elems = document.querySelectorAll(selector);

  if (elems?.length) {
    const firstElem = elems[0];
    const lastElem = elems[elems.length - 1];

    if (!Array.from(elems).includes(document.activeElement)) {
      firstElem.focus();
    }

    if (e.shiftKey) {
      if (document.activeElement === firstElem) {
        lastElem.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastElem) {
        firstElem.focus();
        e.preventDefault();
      }
    }
  }
};

export const getUrlParameter = (param) => {
  param = param.replace(/[\\[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp("[\\?&]" + param + "=([^&#]*)");
  const results = regex.exec(window.location.search);

  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

export const scrollToSection = (selector, isMobile) => {
  const el = document.querySelector(selector);
  if (el) {
    const offset = isMobile ? 150 : 160; // compensate for header
    const elementPosition =
      el.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: elementPosition,
      behavior: "smooth",
    });
  }
};

export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
};

export const extractTextFromElement = (element) => {
  if (element?.props && element?.props?.children) {
    if (typeof element.props.children === "string") {
      return element.props.children;
    } else if (Array.isArray(element.props.children)) {
      const textContentArray = element.props.children.map((child) => {
        if (typeof child === "string") {
          return child;
        } else if (typeof child === "object" && child !== null) {
          return extractTextFromElement(child);
        } else {
          return "";
        }
      });

      return textContentArray.join(" ");
    }
  } else {
    return element;
  }
};

export const isBrowser = () => {
  return typeof window !== "undefined";
};
